import { render, staticRenderFns } from "./TheSourceSorter.vue?vue&type=template&id=0c2ba890&scoped=true&"
import script from "./TheSourceSorter.vue?vue&type=script&lang=js&"
export * from "./TheSourceSorter.vue?vue&type=script&lang=js&"
import style0 from "./TheSourceSorter.vue?vue&type=style&index=0&id=0c2ba890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ba890",
  null
  
)

export default component.exports